import axiosInstance from "./axiosInstance";
import APIEndpoint from "./endpoint";

import { ACCESS_TOKEN } from "../lib/const";

export const getListFileExport = async () => {
  const api = APIEndpoint.EXPORT_CONFIG_FILE_API;
  const res = await axiosInstance.get(api);

  return res;
};

export const exportReportFile = async (request) => {
  const payload = {
    requestObject: request,
  };

  if (!Array.isArray(request.yearOfBudget) || request.yearOfBudget.length === 0) {
    throw new Error("กรุณาเลือกปีงบประมาณ");
  }


  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
      "content-type": "application/json",
    },
    responseType: "blob",
  };

  const api = APIEndpoint.EXPORT_FILE_API;
  const res = await axiosInstance.post(api, JSON.stringify(payload), config);
  return res;
};
